import { Table, Card } from "antd";
import { useEffect, useState } from "react";
import { getPerformanceApi } from "../../../apiservice/crm";


const Performance = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getPerformanceApi()
        .then(res => setData(res.data))
        .finally(() => setLoading(false));
  }, []);

  const columns = [
    { title: "Agent", dataIndex: "full_name" },
    { title: "Leads", dataIndex: "total_leads" },
    { title: "Converted", dataIndex: "converted" },
    { title: "Conversion %", dataIndex: "conversion_rate" },
    { title: "Activities", dataIndex: "activities" },
    { title: "Revenue", dataIndex: "revenue" },
  ];

  return (
    <Card title="Agent Performance">
      <Table dataSource={data} columns={columns} rowKey="id" />
    </Card>
  );
};

export default Performance;